import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/fumadocs-core/dist/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageToggle","LanguageToggleText"] */ "/vercel/path0/node_modules/fumadocs-ui/dist/components/layout/language-toggle.js");
;
import(/* webpackMode: "eager", webpackExports: ["RootToggle"] */ "/vercel/path0/node_modules/fumadocs-ui/dist/components/layout/root-toggle.js");
;
import(/* webpackMode: "eager", webpackExports: ["SearchToggle","LargeSearchToggle"] */ "/vercel/path0/node_modules/fumadocs-ui/dist/components/layout/search-toggle.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/fumadocs-ui/dist/components/layout/sidebar.js");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeToggle"] */ "/vercel/path0/node_modules/fumadocs-ui/dist/components/layout/theme-toggle.js");
;
import(/* webpackMode: "eager", webpackExports: ["HideIfEmpty"] */ "/vercel/path0/node_modules/fumadocs-ui/dist/components/ui/hide-if-empty.js");
;
import(/* webpackMode: "eager", webpackExports: ["NavProvider","StylesProvider"] */ "/vercel/path0/node_modules/fumadocs-ui/dist/contexts/layout.js");
;
import(/* webpackMode: "eager", webpackExports: ["TreeContextProvider"] */ "/vercel/path0/node_modules/fumadocs-ui/dist/contexts/tree.js");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar","NavbarSidebarTrigger","CollapsibleControl"] */ "/vercel/path0/node_modules/fumadocs-ui/dist/layouts/docs-client.js");
;
import(/* webpackMode: "eager", webpackExports: ["BaseLinkItem"] */ "/vercel/path0/node_modules/fumadocs-ui/dist/layouts/links.js");
;
import(/* webpackMode: "eager", webpackExports: ["RootProvider"] */ "/vercel/path0/node_modules/fumadocs-ui/dist/provider/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Figtree\",\"arguments\":[{\"subsets\":[\"latin\"],\"fallback\":[\"-apple-system\",\"BlinkMacSystemFont\",\"avenir next\",\"avenir\",\"segoe ui\",\"helvetica neue\",\"helvetica\",\"Cantarell\",\"Ubuntu\",\"roboto\",\"noto\",\"arial\",\"sans-serif\"]}],\"variableName\":\"figtree\"}");
